export default function populateUTMFields() {
  const cookiesArr = document.cookie.split(';');
  const utmCookies = cookiesArr
    .map(cookie => {
      const [nameRaw, value] = cookie.split('=');
      const name = nameRaw.trim();

      if (!window.UTM_COOKIES.includes(name)) return;

      return [name, value];
    })
    .filter(i => i);

  for (const [key, val] of utmCookies) {
    const field = document.getElementById(key) as HTMLInputElement;

    if (!field || !val) continue;

    field.value = val;
  }
}
